import React, { useEffect } from 'react'
import Card from './Card'
import { ListProductsData } from './data'
import { CollectionWrapper, ListSContainer, TopTitle } from './ListStyle'

export default function Lists() {
  useEffect(() => {
    window.scrollTo(0,0)
  }, [])
  return (
    <ListSContainer>
      <TopTitle>
        <p>menu / submenu</p>
        <h3>hijab collection</h3>
      </TopTitle>
      <CollectionWrapper>
        {
          ListProductsData.map((item, idx) => (
            <Card item={item} key={idx}/>
          ))
        }
      </CollectionWrapper>
    </ListSContainer>
  )
}


// const listRef = useRef()
  // useEffect(() => {
  //   const eventOnScroll = () => {
  //       if (listRef.current) {
  //         window.addEventListener('scroll', () => {
  //             if (window.pageYOffset > 30) {
  //                 listRef.current?.style.marginTop = '5rem'
  //             } else {
  //                 listRef.current?.style.marginTop = '2.5rem'
  //             }
  //         })
  //       }
  //   }
  //   eventOnScroll()
  //   return () => window.removeEventListener('scroll', eventOnScroll)
  // }, [])